import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  deleteRequestStart,
  deleteRequestSuccess,
  deleteRequestFailed,
} from "../redux/deleteRequest";
import { deleteRequestApi } from "core/http/service/timeKeeping";
import {
  listFeedbackDataSelector,
  listRequestLeaveData,
  selectDeleteRequestData,
  selectListArriveLateData,
} from "../redux/selector";
import { toast } from "react-toastify";
import { updateListRequestLeave } from "../redux/getListRequestLeave";
import { updateListArriveLate } from "../redux/getListArriveLate";
import { updateListFeedback } from "../redux/getListFeedback";
import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { getPaidLeaveBalanceStart } from "../redux/getPaidLeaveBalance";
import { SCREEN } from "helper/roleChecker/Screens";
import { getTimeKeepingSummaryStart } from "../redux/getTimeKeepingSummary";
import moment from "moment";

function* deleteRequestWork(action) {
  const id = yield select(selectDeleteRequestData);
  const { screenCode, tab, callback } = action.payload;
  const currentListRequest =
    tab === "leave"
      ? yield select(listRequestLeaveData)
      : tab === "late"
        ? yield select(selectListArriveLateData)
        : yield select(listFeedbackDataSelector);
  try {
    yield call(deleteRequestApi, screenCode, id, tab);

    yield put({
      type: deleteRequestSuccess.type,
    });
    toast.success("Đơn của bạn đã được xóa thành công");
    yield put({
      type: getPaidLeaveBalanceStart.type,
      payload: SCREEN.IP_015,
    });
    yield put({
      type: getTimeKeepingSummaryStart.type,
      payload: {
        year: moment().year(),
        month: moment().month() + 1,
        screenCode: SCREEN.IP_015,
      },
    });

    yield put({
      type:
        tab === "leave"
          ? updateListRequestLeave.type
          : tab === "late"
            ? updateListArriveLate.type
            : updateListFeedback.type,
      payload: currentListRequest.filter((item) => item.id !== id),
    });
    if (callback) {
      callback();
    }
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: deleteRequestFailed.type,
    });
  }
}

function* watchDeleteRequest() {
  yield takeLatest(deleteRequestStart.type, deleteRequestWork);
}

export default function* deleteRequestSaga() {
  yield all([watchDeleteRequest()]);
}
